// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y1AtR{display:flex;width:100%;gap:24px;padding-right:72px}.KC4zH{width:100%;height:100%}`, "",{"version":3,"sources":["webpack://./src/pages/instamart/home/widgets/Layout/Layout.module.scss"],"names":[],"mappings":"AAAA,OACI,YAAA,CACA,UAAA,CACA,QAAA,CACA,kBAAA,CAGJ,OACI,UAAA,CACA,WAAA","sourcesContent":[".container {\n    display: flex;\n    width: 100%;\n    gap: 24px;\n    padding-right: 72px;\n}\n\n.content {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Y1AtR`,
	"content": `KC4zH`
};
export default ___CSS_LOADER_EXPORT___;
